var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"LoadingScreen",attrs:{"id":"LoadingScreen"}},[_c('div',{staticClass:"center"},[_c('p',{ref:"workerStatus",staticClass:"loadingStatus"},[_vm._v(" Loading Static Files, Please wait... ")]),_vm._m(0)])]),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loaderBar"})])
}]

export { render, staticRenderFns }